function EditDoc(props: any) {
    return (
        <div className={props.className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10.1336 17.5V15.1938L15.1527 10.2813L17.5 12.5688L12.4809 17.5H10.1336ZM11.2786 16.375H12.0038L14.313 14.0875L13.9695 13.7313L13.6069 13.3938L11.2786 15.6625V16.375ZM2.5 17.5V2.5H10.1336L14.7137 7V9.25H13.187V7.75H9.37023V4H4.02672V16H8.60687V17.5H2.5ZM13.9695 13.7313L13.6069 13.3938L14.313 14.0875L13.9695 13.7313Z" fill="currentColor" />
            </svg>
        </div>
    );
}

export default EditDoc;
